<app-doc-viewer title="Feature" subtitle="Geo">
  <app-example-viewer codeFolder="geo/feature">
    <igo-map-browser [map]="map" [view]="view">
      <div class="map-actions --vertical --bottom --right">
        <igo-zoom-button [map]="map" color="primary" />
      </div>
    </igo-map-browser>

    <igo-entity-table [store]="store" [template]="tableTemplate" />
  </app-example-viewer>
</app-doc-viewer>
